import React from 'react'
import Yup from './../../../../helpers/custom-yup'
import Title from './../../../../components/typography/title.component'
import MovePointsForm from './components/move-points-form.component'
import ModalConfirmation from '../../../../components/modal/modal-confirmation.component'
import InnerPageContainer from './../../../../components/layout/private/inner-page-container.component'
import { Formik } from 'formik'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { MOVEFLEX_NUMBERS } from '../../../../constants'
import { BlockchainService } from '../../../../services/blockchain.service'
import { bindActionCreators } from 'redux'
import { Creators as SiteCreators } from '../../../../ducks/site/site'
import { adminActions, toastActions } from '../../../../actions'
import * as movePointsActions from './move-points.actions'

class MovePointsPageComponent extends React.Component {
	constructor(props) {
		super(props)
		this.props = props
		this.state = {
			showConfirmationModal: false,
			initialValues: {
				value: 0,
				sourceMoveflexNumber: MOVEFLEX_NUMBERS.MOVEFLEX,
				destinationMoveflexNumber: null,
				securityKey: '',
				notes: ''
			}
		}
		this.baseState = this.state
	}

	onSubmit = (values, actions) => {
		const { warning } = this.props
		if (values.sourceMoveflexNumber == values.destinationMoveflexNumber) {
			warning({
				message:
					'Não é possível movimentar pontos para mesma origem e destino'
			})
			return
		}

		this.values = values
		this.actions = actions
		this.setState({ showConfirmationModal: true })
	}

	handleModalResponse = async response => {
		this.setState({ showConfirmationModal: false })

		if (response) {
			const {
				danger,
				success,
				showLoading,
				hideLoading,
				adminGetBalancePoints
			} = this.props

			showLoading()

			BlockchainService.movePoints(this.values)
				.then(data => {
					hideLoading()
					data.success
						? success({ message: 'Pontos movimentados com sucesso' })
						: danger({ message: data.errors[0] })

					if (
						this.values.sourceMoveflexNumber ==
							MOVEFLEX_NUMBERS.MOVEFLEX ||
						this.values.destinationMoveflexNumber ==
							MOVEFLEX_NUMBERS.MOVEFLEX
					) {
						adminGetBalancePoints()
					}

					this.refs.form.resetForm(this.baseState.initialValues)
					this.setState(this.baseState, () => {
						this.refs.form.refs.movePointsForm.updateSource()
					})
				})
				.catch(() => {
					hideLoading()
					danger({ message: 'Falha ao movimentar pontos' })
				})
		}
	}

	render() {
		const { initialValues, showConfirmationModal } = this.state
		const { sender, receiver } = this.props
		const getName = user => user && user.split('-')[0].trim()
		return (
			<InnerPageContainer>
				<Title>Movimentar Pontos Muviflex</Title>
				<Formik
					ref="form"
					initialValues={initialValues}
					onSubmit={this.onSubmit}
					validationSchema={Yup.object().shape({
						value: Yup.number()
							.min(1, 'Valor inválido')
							.required('Informe a quantidade'),
						securityKey: Yup.string()
							.matches(/^[0-9]{4}$/, 'Chave de segurança inválida')
							.required('Informe a chave de segurança'),
						sourceMoveflexNumber: Yup.string()
							.nullable()
							.required('Informe uma conta de origem'),
						destinationMoveflexNumber: Yup.string()
							.nullable()
							.required('Informe uma conta de destino'),
						notes: Yup.string().required('A observação é obrigatória')
					})}
					render={props => (
						<MovePointsForm
							ref="movePointsForm"
							{...props}
							{...this.props}
						/>
					)}
				/>
				<ModalConfirmation
					title="Confirmação"
					isOpen={showConfirmationModal}
					onResult={this.handleModalResponse}>
					Confirma movimentação de{' '}
					<span className="bold">
						{this.values ? this.values.value : ''}{' '}
					</span>
					pontos Muviflex de{' '}
					<span className="bold orange">
						{sender && getName(sender.name)}
					</span>{' '}
					para{' '}
					<span className="bold blue">
						{receiver && getName(receiver.name)}
					</span>
					?
				</ModalConfirmation>
			</InnerPageContainer>
		)
	}
}

const mapStateToProps = ({ adminMovePoints }) => {
	return {
		...adminMovePoints
	}
}

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			...SiteCreators,
			...toastActions,
			...movePointsActions,
			adminGetBalancePoints: adminActions.getBalancePoints
		},
		dispatch
	)

const connectedMovePointsPageComponent = withRouter(
	connect(
		mapStateToProps,
		mapDispatchToProps
	)(MovePointsPageComponent)
)

export { connectedMovePointsPageComponent as ModuleRootComponent }
